import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import sensor, {fromAPIData} from "../sensor";

Vue.use(Vuex);

const state = {
    user: null,
    loginAttempts: 0,
    sensors: [],
    contacts: [],
    alerting_contacts: [],
    context: null,
    contextPath: [],
    language: 'da',
    firmware_versions: []
};


export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    modules: {
        //auth,
    },
    debug: process.env.NODE_ENV !== 'production',
    strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js